import { getRewardValue } from "@focuslee/shared";
import { GoalPlan } from "../client/generated/graphql";
import { ListGoal } from "../client/types";

export const getTargetXP = (goal: ListGoal, weekDay: number) => {
    const weekTargetXP = (goal.targetLevel === 3 || goal.targetLevel === null)
        ? goal.l3Target 
        : goal.targetLevel === 2 
            ? goal.l2Target
            : goal.l1Target;
    
    const isWeekend = weekDay >=6 || weekDay < 1;
    switch(goal.targetPlan){
        case GoalPlan.WorkdaysOnly:
            if (isWeekend)
                return 0;
            return Math.ceil(weekTargetXP / 5);
        case GoalPlan.WorkdaysWithExtraEffort:
            if (isWeekend)
                return Math.ceil(weekTargetXP * 0.1);
            return Math.ceil(weekTargetXP * 0.16);
        case GoalPlan.WeekendBoost:
            if (isWeekend)
                return Math.ceil(weekTargetXP * 0.2);
            return Math.ceil(weekTargetXP * 0.12);
        case GoalPlan.WeekendOnly:
            if (isWeekend)
                return Math.ceil(weekTargetXP * 0.5);
            return 0;
        case GoalPlan.ConsistentDailyEffort:
        default:
            return Math.ceil(weekTargetXP * 0.143);
    }
};

export const getTotalReward = (goals: ListGoal[]): number => {  
    return goals.reduce((sum, g) => sum + getRewardValue(g), 0);
}

export function getLevelTargetXP(goal: ListGoal): number {
    switch (goal.targetLevel) {
        case 1: return goal.l1Target;
        case 2: return goal.l2Target;
        case 3: return goal.l3Target;
        default: return goal.l3Target;
    }
}

export function getSpecificLevelTargetXP(goal: ListGoal, level: number): number {
    switch (level) {
        case 1: return goal.l1Target;
        case 2: return goal.l2Target;
        case 3: return goal.l3Target;
        default: return 0;
    }
}